import { format } from 'date-fns';
import { es } from 'date-fns/locale';

import { PetitionComment } from '../../../../types/petition-comment.type';
import { capitalize } from '../../../../utils/string.util';

import styles from './petition-comment.module.scss';

type Props = {
    comment: PetitionComment;
};

const PetitionCommentCard = ({ comment }: Props) => {
    return (
        <li className={styles.comment}>
            <div className={styles.metadata}>
                <span
                    className={styles.authorName}
                    data-id={comment.author?.id}
                >
                    @{comment.author?.firstName} {comment.author?.lastName}
                </span>
                <span className={styles.date}>
                    {format(
                        new Date(comment.createdAt),
                        'MMMM dd, yyyy hh:mm:ss aaaa',
                        { locale: es }
                    )}
                </span>
            </div>
            <span className={styles.content}>
                {capitalize(comment.content)}
            </span>
        </li>
    );
};

export default PetitionCommentCard;
